import { Preferences } from '@3ds/common-preferences'
import { DS_LANG } from '@ds/swymkit/config'

export const DS_BASE_URL = Preferences.isNativeApp() ? `${window.location.origin}/` : (window.dsDefaultWebappsBaseUrl?.replace('webapps/', '') || `${window.location.origin}/`)

/**
 * The Swym Webapps Base URL
 * @example
 * - "https://swym.com/webapps" // for standalone or widgets
 * - "http://127.0.0.1/webapps" // for NativeAPP
 */
export const DS_WEBAPPS_URL = Preferences.isNativeApp() ? `${DS_BASE_URL}webapps/` : (window.dsDefaultWebappsBaseUrl || `${DS_BASE_URL}webapps/`)
export const DS_UWP_PREFIX = 'uwp/'

/**
 * The resources URL accessible on UWP
 * @example
 * - "https://swym.com/uwp/" // for standalone or widgets
 * - "http://127.0.0.1/uwp/" // for NativeAPP
 */
export const DS_RESOURCE_URL = DS_BASE_URL + DS_UWP_PREFIX

export function setupNativeEnvVar() {
  const configs = Preferences.getNativeAppRequireConfig()
  if (configs) {
    window.ds = { ...window.ds, ...configs.dsEnv }
    window.UWA.hosts.proxies = configs.proxies
  }
}

// eslint-disable-next-line max-statements
export function initGlobalVars() {
  window.ds = {
    anonymous: false,
    env: '3DSwym',
    app: '3DSwym',
  }
  window.dsx = {}
  window.dsPrefix = DS_UWP_PREFIX
  window.dsLang = DS_LANG
  window.dsVersion = '0'
  window.dsBaseUrl = DS_BASE_URL
  window.dsResourceUrl = DS_RESOURCE_URL
  window.dsDefaultWebappsBaseUrl = DS_WEBAPPS_URL
  window.dsUserGranted = true
  window.dsCsrfOptions = window.widget?.id ? undefined : { protection: false }
  window.dsUntrustedBaseUrl = ''
  window.dsDefaultLoadedBundles = []
  window.dsPlatformPrefixUrlEnabled = true

  // Bundles configurations
  window.bundles = { V6frame: [], wp: [], swym: [] }

  // Widget App Platform global variables
  window.wap = { widgetInstancesCacheId: 'F88j1' }

  // UWA configurations
  window.UWA = {
    ...window.UWA,
    hosts: {
      uwa: (`${DS_BASE_URL + DS_UWP_PREFIX}resources/0/${DS_LANG}/wp`),
      exposition: (`${DS_BASE_URL + DS_UWP_PREFIX}api`),
      untrustedExposition: (`${window.dsUntrustedBaseUrl + DS_UWP_PREFIX}api`),
      proxies: {
        passport: (`${DS_BASE_URL + DS_UWP_PREFIX}api/proxy/passport`),
      },
    },
  }

  setupNativeEnvVar()
}
